import { requestGet } from '@/common/request';

export interface towerIdsValidateParams {
  towerIds: string;
  channelId?: string;
}

export interface towerIdsValidateRes {
  ret: string;
  msg: string;
  data?: {};
}

//频道管理 - 校验通天塔id相关
export async function towerIdsValidate(params: towerIdsValidateParams): Promise<towerIdsValidateRes> {
  return await requestGet('/channelActivity/towerIdsValidate', params);
}
